module.exports = __webpack_public_path__ + "static/media/arrow-down.b4c88c5d.png";